<template>
  <div v-if="show">
    <TopNav
      v-if="hasHeaderBar"
      @click-back="back"
      :title="title || $store.state.currentFunctionName"
    ></TopNav>
    <main
      class="container"
      style="padding-top:60px;"
      :style="{ 'padding-bottom': (hasBottomButton=='true' && '70px') || 0,
      'padding-top': (hasHeaderBar &&'60px') || 0 }"
    >
      <slot></slot>
    </main>
  </div>
</template>
<script>
import TopNav from "@/components/TopNav/TopNav.vue";
export default {
  name: "BaseLayout",
  data: function() {
    return {
      show: true
    };
  },
  props: ["title", "isFunction", "hasBottomButton", "hasHeaderBar"],
  components: {
    TopNav: TopNav
  },
  methods: {
    back: function() {
      this.$emit("click-back");
    },
    checkFunction: function() {
      if (!this.$store.state.currentFunctionId) {
        // this.show = false;
        // this.$router.push("/menu");
      } else {
      }
    }
  },
  mounted: function() {},
  created: function() {
    //debugger;
    // alert("create");
    // alert(this.isFunction);
    if (this.isFunction == "true") {
      // alert("create");
      // alert(this.isFunction);
      this.checkFunction();
    }
  }
};
</script> 

<style lang="scss" scoped>
.container {
  padding-right: 0;
  padding-left: 0;
}
.container .row {
  margin-right: 0;
  margin-left: 0;
}
</style>
